export const CLICK_TRACKING_EVENT = 'clicktrackingevent'

export const DATA_ANALYTICS = {
  CLICK: CLICK_TRACKING_EVENT
} as const

export const DATA_OBJECTS = {
  BUTTON: 'button',
  LINK: 'link'
} as const

export type DataObjects = (typeof DATA_OBJECTS)[keyof typeof DATA_OBJECTS]
export type DataAnalytics = (typeof DATA_ANALYTICS)[keyof typeof DATA_ANALYTICS]
